export const aboutInfo = {
  brandName: "磁力金牛",
  brandSlogan: "强力吸金的财富增长利器",
  brandStory: `磁力金牛诞生于2023年，由一群拥有超过15年金融科技经验的专家团队创立。我们的使命是让每个人都能享受到专业级的智能财富管理服务，无论你的资金规模大小、投资经验多少。

"磁力"象征着我们对市场机会的敏锐捕捉能力，"金牛"代表着稳健增长与财富积累。我们相信，在人工智能和大数据技术的赋能下，财富管理不应该是少数人的特权。

经过三年的持续迭代，磁力金牛已服务超过50万用户，累计帮助用户创造收益超过30亿元。我们的智能引擎每天处理超过10亿条市场数据，运行500+个AI策略模型，致力于为每一位用户提供最优的财富增长方案。`,
  coreValues: [
    {
      title: "技术驱动",
      description: "以AI和大数据为核心驱动力，持续优化策略算法，保持技术领先优势",
      icon: "ri-cpu-line",
    },
    {
      title: "用户至上",
      description: "每一个产品决策都以用户利益为出发点，透明收费、数据安全、服务贴心",
      icon: "ri-heart-line",
    },
    {
      title: "稳健合规",
      description: "严格遵守金融监管要求，持有合法经营资质，用户资金由持牌机构托管",
      icon: "ri-shield-check-line",
    },
    {
      title: "持续创新",
      description: "不断探索新的策略模型和技术方案，保持产品的竞争力和前瞻性",
      icon: "ri-lightbulb-flash-line",
    },
  ],
  milestones: [
    { year: "2023年6月", event: "磁力金牛项目立项，核心团队组建完成" },
    { year: "2023年12月", event: "磁力金牛1.0版本上线，首批1000名内测用户入驻" },
    { year: "2024年3月", event: "用户突破5万人，累计收益突破1亿元" },
    { year: "2024年9月", event: "发布2.0版本，引入AI策略引擎，策略胜率提升40%" },
    { year: "2025年1月", event: "用户突破20万人，推出移动端应用" },
    { year: "2025年6月", event: "获得知名风投A轮融资5000万元" },
    { year: "2025年12月", event: "用户突破50万人，累计为用户创造收益超30亿元" },
    { year: "2026年3月", event: "发布3.0版本，全面升级吸金引擎，策略种类扩充至50+" },
    { year: "2026年7月", event: "推出旗舰版服务，为用户提供一对一专属财富顾问" },
  ],
  testimonials: [
    {
      name: "王女士",
      role: "退休教师",
      content: "我用磁力金牛已经大半年了，从什么都不懂到现在每个月稳稳赚几千块，真的特别感谢这个产品。操作简单，收益稳定，推荐给了好多老姐妹。",
      rating: 5,
    },
    {
      name: "张先生",
      role: "设计公司创始人",
      content: "创业五年，最焦虑的就是现金流。磁力金牛帮我建立了一份稳定的被动收入，让我能更专注于主业发展。现在每个月从磁力金牛的收入已经能覆盖公司一半的房租了。",
      rating: 5,
    },
    {
      name: "陈同学",
      role: "大学生",
      content: "从2000块钱开始用磁力金牛，到现在账户翻了十几倍。作为学生党，这是我做过最正确的理财决定。虽然起点低，但只要开始并坚持，复利的力量真的很强大。",
      rating: 5,
    },
    {
      name: "李先生",
      role: "IT工程师",
      content: "我比较忙，没时间天天盯盘研究。磁力金牛的全自动策略完美解决了这个问题，设置好之后基本上不用管，每个月看看收益报表就行。已经推荐给整个部门了。",
      rating: 5,
    },
    {
      name: "赵女士",
      role: "全职妈妈",
      content: "带娃之余想找点事情做，朋友推荐了磁力金牛。一开始只敢放几千块试试，现在越来越有信心，收益也比预期好。客服响应也很快，遇到问题随时都能解决。",
      rating: 4,
    },
    {
      name: "刘先生",
      role: "自由职业者",
      content: "自由职业收入不稳定，所以特别需要一份被动收入作为保障。磁力金牛的稳健策略很适合我，每个月都有一笔稳定的额外收入，让我的生活从容了很多。",
      rating: 5,
    },
  ],
  contact: {
    phone: "400-888-6666",
    email: "support@cicjinni.com",
    address: "深圳市南山区科技园南路88号磁力大厦18层",
    workingHours: "周一至周五 9:00 - 21:00",
    wechat: "cicjinni_official",
  },
};